/**************************************************
 * Nombre:       Tarjeta_Oferta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {East} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Icono_No_Boton from "../Secciones/Componentes/Subcomponentes/Icono_No_Boton";
import Icono_Texto from "../Secciones/Componentes/Subcomponentes/Icono_Texto";
import {useNavigate} from "react-router";


const Tarjeta_Oferta = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#ffffff',
                color: theme.palette.primary.main,
                boxShadow: 4,
                borderRadius: 2,
                overflow: 'hidden',
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: 'url(' + item.img + ')',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    height: sCell ? 200 : 280
                }}
            >

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    py: 3,
                    px: 4
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0}}>
                    <Typography sx={{
                        textAlign: sCell ? 'center' : 'left',
                        lineHeight: 1.1,
                        fontSize: sCell ? 18 : 24,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                    }}>{item.nombre}</Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                    sx={{mt: 2}}
                >

                    {item && item.puntos && item.puntos.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Icono_No_Boton item={item}/>
                        </Grid>
                    ))}

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                    <Typography sx={{fontSize: 18, fontWeight: 600, lineHeight: 1.3}}>
                        {item.subtitulo}
                    </Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                    sx={{mt: 3}}
                >

                    {item && item.contamos && item.contamos.map((item, index) => {

                            if (index < 3) {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Icono_Texto item={item}/>
                                    </Grid>
                                )
                            }

                        }
                    )}

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4, mb: 1}}>
                    <Button
                        onClick={() => navigate('/DetalleOferta/' + item.nombre.replace(/ /g, '-'))}
                        endIcon={<East/>} fullWidth sx={{borderRadius: 1}}>
                        Ver Mas
                    </Button>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Oferta

